function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 2,
  y: 3.41418,
  width: 2,
  height: 20,
  transform: "rotate(-45 2 3.41418)"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "currentColor",
  x: 3.41418,
  y: 17.5565,
  width: 2,
  height: 20,
  transform: "rotate(-135 3.41418 17.5565)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCBmaWxsPSJjdXJyZW50Q29sb3IiIHg9IjIiIHk9IjMuNDE0MTgiIHdpZHRoPSIyIiBoZWlnaHQ9IjIwIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgMiAzLjQxNDE4KSIgLz4KICA8cmVjdCBmaWxsPSJjdXJyZW50Q29sb3IiIHg9IjMuNDE0MTgiIHk9IjE3LjU1NjUiIHdpZHRoPSIyIiBoZWlnaHQ9IjIwIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTM1IDMuNDE0MTggMTcuNTU2NSkiIC8+Cjwvc3ZnPgo=';
export { SvgComponent as ReactComponent };